import { render, staticRenderFns } from "./SalesDataList.vue?vue&type=template&id=15837a70"
import script from "./SalesDataList.vue?vue&type=script&lang=js"
export * from "./SalesDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports